import React from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import { Redirect, Route, useRouteMatch } from "react-router-dom";
import withAuthorization from "../auth/withAuthorization";
import ProjectView from "./ProjectView";
import ProgramBrowseView from "./ProgramBrowseView";
import ProgramView from "./ProgramView";
import { usePrograms } from "./cspServices";

const AuthorizedRoute = withAuthorization(Route);

const ManageCSPsView = () => {
  const { path } = useRouteMatch();

  const programsResponse = usePrograms();

  return (
    <Container id="manage-subscriptions" disableGutters>
      <ApplicationHeader />

      <AuthorizedRoute exact path={`${path}/programs`} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel id="application-panel-programs">
          <ProgramBrowseView programsResponse={programsResponse} />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute
        exact
        path={`${path}/programs/:programId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-program">
          <ProgramView />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute
        exact
        path={`${path}/programs/:programId/projects/:projectId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-project">
          <ProjectView />
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route exact path={path}>
        <Redirect to={`${path}/programs`} />
      </Route>
    </Container>
  );
};

export default ManageCSPsView;
